import { Component, Inject, OnInit, Optional } from '@angular/core';
import { Router } from '@angular/router';
import { tap } from 'rxjs/operators';

import {
    takeUntilDestroy,
    TakeUntilDestroy,
} from '../../../../common/take-until-destroy.decorator';
import { ScorecardDataService } from '../../../core/data.service';
import { OverallScoreData } from '../../../core/overall-score-data.model';
import { OverallScoreGridOptions } from '../../../core/overall-score-grid-options.model';
import { Widget, WidgetType } from '../../../core/template-definition.model';
import { TrendType } from '../../../core/trend-type.model';
import { CMPS_SCORECARD_WIDGET } from '../../../scorecard.metadata';
import { TranslationKeyMap } from '../../pulse-widget.i18n';

@Component({
    selector: 'cmps-overall-pulse-widget',
    templateUrl: './overall-pulse-widget.component.html',
    host: {
        class: 'cmps-overall-pulse-widget',
    },
})
@TakeUntilDestroy()
export class ScOverallPulseWidgetComponent implements OnInit {
    /** @private */ _i18n = TranslationKeyMap;
    /** @private */ _TrendType = TrendType;
    /** @private */ _collapsed: boolean;
    /** @private */ _data: OverallScoreData;

    constructor(
        private readonly _router: Router,
        private readonly _dataService: ScorecardDataService,
        @Optional()
        @Inject(CMPS_SCORECARD_WIDGET) /** @private */
        public _widget: Widget<OverallScoreGridOptions>,
    ) {}

    ngOnInit(): void {
        this._dataService
            .observableForWidgetType<OverallScoreData>(
                WidgetType.OVERALL_SCORE_GRID,
            )
            .pipe(
                tap((data) => {
                    this._data = data;
                }),
                takeUntilDestroy(this),
            )
            .subscribe();
    }

    /** @private */
    _onScoreClick(): void {
        if (!this._data || !this._data.header) {
            return;
        }
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._router.navigate(
            [
                'scorecards',
                this._data.header.userId,
                this._data.header.scorecardId,
            ],
            {
                queryParams: {
                    periodTypeId: this._data.header.periodType,
                },
            },
        );
    }
}
